import { inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { User } from '../models';
import { STORAGE_KEYS } from '../storage/storage-prefix';
import { EncryptionService } from './encryption.service';

@Injectable({ providedIn: 'root' })
export class UserService {

  private readonly _encryptionService = inject(EncryptionService);

  private _user: ReplaySubject<User | null> = new ReplaySubject<User | null>(1);

  set user(value: User | null) {
    this._user.next(value);
  }

  get user$(): Observable<User | null> {
    return this._user.asObservable();
  }

  set userInfo(value: User | null) {
    if (value === null) {
      localStorage.removeItem(STORAGE_KEYS.AUTH.USER_INFO);
      return;
    }
    const encrypted = this._encryptionService.encryptAES256(value);
    localStorage.setItem(STORAGE_KEYS.AUTH.USER_INFO, encrypted);
  }

  get userInfo(): User | null {
    const decrypted = localStorage.getItem(STORAGE_KEYS.AUTH.USER_INFO);
    return this._encryptionService.decryptAES256(decrypted) ?? null;
  }

  set username(value: string | null) {
    if (value === null) {
      localStorage.removeItem(STORAGE_KEYS.AUTH.USERNAME);
      return;
    }
    const encrypted = this._encryptionService.encryptAES256(value);
    localStorage.setItem(STORAGE_KEYS.AUTH.USERNAME, encrypted);
  }

  get username(): string | null {
    const decrypted = localStorage.getItem(STORAGE_KEYS.AUTH.USERNAME);
    return this._encryptionService.decryptAES256(decrypted) ?? '';
  }

  clear(): void {
    this.user = null;
    this.userInfo = null;
    this.username = null;
  }

}
